import { SvgIcon } from "@mui/material";
import React from "react";

function PatientsIcon(props) {
  return (
    <SvgIcon viewBox="0 0 22 22" {...props}>
      <path
        d="M8.3966 9.96286C8.30493 9.9537 8.19493 9.9537 8.0941 9.96286C5.91243 9.88953 4.17993 8.10203 4.17993 5.90203C4.17993 3.6562 5.99493 1.83203 8.24993 1.83203C10.4958 1.83203 12.3199 3.6562 12.3199 5.90203C12.3108 8.10203 10.5783 9.88953 8.3966 9.96286Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0425 3.66797C16.8208 3.66797 18.2508 5.10714 18.2508 6.8763C18.2508 8.6088 16.8758 10.0205 15.1617 10.0846C15.0883 10.0755 15.0058 10.0755 14.9233 10.0846"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.81341 13.348C1.59507 14.833 1.59507 17.253 3.81341 18.7288C6.33424 20.4155 10.4684 20.4155 12.9892 18.7288C15.2076 17.2438 15.2076 14.8238 12.9892 13.348C10.4776 11.6705 6.34341 11.6705 3.81341 13.348Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8118 18.332C17.4718 18.1945 18.0951 17.9287 18.6084 17.5345C20.0384 16.462 20.0384 14.6929 18.6084 13.6204C18.1043 13.2354 17.4901 12.9787 16.8393 12.832"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default PatientsIcon;
